export default "__VITE_ASSET__89208c3e__"